import React from "react"

const Storage = props => <span>{props.capacity}GB</span>

export default Storage